__turbopack_context__.v({
  "active": "PillButton-module-scss-module__3yqNfq__active",
  "label": "PillButton-module-scss-module__3yqNfq__label",
  "larger": "PillButton-module-scss-module__3yqNfq__larger",
  "pillButton": "PillButton-module-scss-module__3yqNfq__pillButton",
  "smaller": "PillButton-module-scss-module__3yqNfq__smaller",
});
